module.exports = __webpack_public_path__ + "img/theme5.1fa75fab.png";